import React from 'react'
import { View, useStyles } from '@ion-ui/core'
import { Styles } from './styles'

const CurveGeneral = () => {
  const styles = useStyles(Styles)
  return (
    <View variant='section' css={styles.containerCurve}>
      <View variant='article' css={styles.curveL}></View>
      <View variant='article' css={styles.curveR}></View>
    </View>

  )
}

export default CurveGeneral
